import React, { useState, useEffect, useRef } from 'react';
import '../../../../styles/resume-editor.css';

interface AIInjectionProps {
  onAIInjectionChange?: (settings: {
    font_size?: number;
    line_height?: string;
    display_font?: string;
    heading_font?: string;
    text_font?: string;
    page_size?: string;
    margins?: { left?: number; right?: number; top?: number; bottom?: number };
    layout?: string;
    is_headshot?: boolean;
    headshot_url?: string;
    headshot_format?: 'circle' | 'square';
    is_ai_injection?: boolean;
    date_format?: string;
    social_display_format?: 'alias' | 'url';
  }) => void;
  cvUid?: string;
  initialAIInjection?: boolean;
}

export const AIInjection: React.FC<AIInjectionProps> = ({ 
  onAIInjectionChange, 
  cvUid,
  initialAIInjection 
}) => {
  const [includeAIInjection, setIncludeAIInjection] = useState(initialAIInjection ?? false);
  const prevAIInjectionRef = useRef<boolean>(initialAIInjection ?? false);

  useEffect(() => {
    if (initialAIInjection !== undefined) {
      setIncludeAIInjection(initialAIInjection);
      prevAIInjectionRef.current = initialAIInjection;
    }
  }, [initialAIInjection]);

  return (
    <div className="resume-editor__section-expanded-body">
      <div className="headshot__toggle-section">
        <label className="headshot__toggle-label">
          <span className="headshot__toggle-text">AI Injection</span>
          <div
            className={`headshot__toggle-switch ${includeAIInjection ? 'headshot__toggle-switch--active' : ''}`}
            onClick={() => {
              const newValue = !includeAIInjection;
              if (newValue !== prevAIInjectionRef.current) {
                setIncludeAIInjection(newValue);
                prevAIInjectionRef.current = newValue;
                onAIInjectionChange?.({ is_ai_injection: newValue });
              }
            }}
          >
            <div className="headshot__toggle-switch-thumb" />
          </div>
        </label>
      </div>

      <div className="headshot__tip-box">
        <div className="headshot__tip-content">
          <div className="headshot__tip-text">
            <strong>Tip:</strong> AI Injection helps enhance your resume with AI-powered suggestions and improvements.
          </div>
          <a href="#" className="headshot__tip-link" onClick={(e) => e.preventDefault()}>
            Learn more
          </a>
        </div>
      </div>
    </div>
  );
};
